import { api } from '@/plugins/axios'
import { IDiscountPayload, ITierPayload, TSetPaymentSystemPayload } from '@/modules/Payment/types'
import { IEvent } from '@/enitites/event'
import { AxiosResponse } from 'axios'

export const setPaymentSystem = async (arg: { eventId: number; payload: TSetPaymentSystemPayload }) => {
  const res = await api.post<TSetPaymentSystemPayload, AxiosResponse<IEvent>>(
    `/events/${arg.eventId}/payment-system`,
    arg.payload
  )
  return res.data
}

export const addTier = async (arg: { eventId: number; payload: ITierPayload }) => {
  const res = await api.post<ITierPayload, AxiosResponse<IEvent>>(`/events/${arg.eventId}/add-tier`, arg.payload)
  return res.data
}

export const updateTier = async (arg: { tierId: number; payload: ITierPayload }) => {
  const res = await api.put<ITierPayload, AxiosResponse<IEvent>>(`/tiers/${arg.tierId}`, arg.payload)
  return res.data
}

export const deleteTier = async (arg: { tierId: number; eventId: number }) => {
  const res = await api.delete<string>(`/tiers/${arg.tierId}`)
  return { eventId: arg.eventId, message: res.data }
}

export const addDiscount = async (arg: { eventId: number; payload: IDiscountPayload }) => {
  const res = await api.post<IDiscountPayload, AxiosResponse<IEvent>>(
    `/events/${arg.eventId}/add-discount`,
    arg.payload
  )
  return res.data
}

export const updateDiscount = async (arg: { discountId: number; payload: IDiscountPayload }) => {
  const res = await api.put<IDiscountPayload, AxiosResponse<IEvent>>(`/discounts/${arg.discountId}`, arg.payload)
  return res.data
}

export const deleteDiscount = async (arg: { discountId: number; eventId: number }) => {
  const res = await api.delete<string>(`/discounts/${arg.discountId}`)
  return { eventId: arg.eventId, message: res.data }
}
